import React from 'react'
import PropTypes from 'prop-types'

import Autosuggest from 'react-autosuggest'
import match from 'autosuggest-highlight/match'
import parse from 'autosuggest-highlight/parse'
import TextField from '@material-ui/core/TextField'
import Paper from '@material-ui/core/Paper'
import MenuItem from '@material-ui/core/MenuItem'
import { withStyles } from '@material-ui/core/styles'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'

const Input = props => {
  const {classes, ref, label, disabled, ...other} = props

  return <div className="script-log-template-text-field">
    <TextField
      fullWidth
      inputRef={ref}
      label={label}
      disabled={disabled}
      InputProps={{
        classes: {
          input: classes.input
        },
        ...other
      }}
    />
    <ArrowDropDownIcon style={{
      position: 'absolute',
      right: 0,
      top: 30
    }}/>
  </div>
}

const renderSuggestion = (suggestion, {query, isHighlighted}) => {
  const matches = match(suggestion, query)
  const parts = parse(suggestion, matches)

  return <MenuItem selected={isHighlighted} component="div">
    <div>
      {parts.map((part, index) => {
        return part.highlight ? (
          <span key={String(index)} style={{fontWeight: 300}}>
              {part.text}
            </span>
        ) : (
          <strong key={String(index)} style={{fontWeight: 500}}>
            {part.text}
          </strong>
        )
      })}
    </div>
  </MenuItem>
}

function renderSuggestionsContainer (options) {
  const {containerProps, children} = options

  return (
    <Paper {...containerProps} square>
      {children}
    </Paper>
  )
}

const styles = theme => ({
  container: {
    flexGrow: 1,
    position: 'relative'
  },
  suggestionsContainer: {
    zIndex: 10
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit * 3,
    left: 0,
    right: 0
  },
  suggestion: {
    display: 'block'
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    listStyleType: 'none',
    backgroundColor: 'white',
    zIndex: 10
  }
})

const escapeRegexCharacters = string => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

class AutosuggestField extends React.Component {
  state = {
    suggestions: []
  }

  getSuggestions (value) {
    const escapedValue = escapeRegexCharacters(value.trim())
    const regex = new RegExp('^' + escapedValue, 'i')

    return this.props.suggestions.filter(language => regex.test(language))
  }

  handleSuggestionsFetchRequested = ({value}) => {
    this.setState({
      suggestions: this.getSuggestions(value)
    })
  }

  handleSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    })
  }

  render () {
    const {classes, label, value, onChange, disabled} = this.props

    return <Autosuggest
      theme={{
        container: classes.container,
        suggestionsContainerOpen: classes.suggestionsContainerOpen,
        suggestionsContainer: classes.suggestionsContainer,
        suggestionsList: classes.suggestionsList,
        suggestion: classes.suggestion
      }}
      renderInputComponent={Input}
      suggestions={this.state.suggestions}
      onSuggestionsFetchRequested={this.handleSuggestionsFetchRequested}
      onSuggestionsClearRequested={this.handleSuggestionsClearRequested}
      renderSuggestionsContainer={renderSuggestionsContainer}
      shouldRenderSuggestions={() => true}
      getSuggestionValue={a => a}
      renderSuggestion={renderSuggestion}
      inputProps={{
        classes,
        value,
        label,
        disabled,
        onChange: (event, {newValue}) => {
          onChange(newValue)
        }
      }}
    />
  }
}

AutosuggestField.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
  suggestions: PropTypes.array,
  disabled: PropTypes.bool
}

AutosuggestField.defaultProps = {
  suggestions: [],
  value: '',
  disabled: false
}

export default withStyles(styles)(AutosuggestField)


// WEBPACK FOOTER //
// ./components/AutosuggestField/index.js